import React, { useRef } from 'react';
import { useTooltip } from "../../../Tooltip";
import { onMouseEnterHandlerDecorator, TooltipText } from "../../../Grid/cellRenderers/helpers";
import { TEXT_SIZE } from "../../../Text";
import { styles } from './styles';
import { cn } from "../../../helpers";
import { COLUMN_CONTENT_JUSTIFY } from "../../GridCore.public";
export var GridNormalCell = React.memo(function GridNormalCell(props) {
    var ref = useRef(null);
    var isText = typeof props.content === 'string' || typeof props.content === 'number';
    var textContent = useTooltip({
        delayTimeout: 500,
        maxWidth: (props.tooltipMaxWidth || props.columnWidth + 50) + "px",
        renderContent: function () { return React.createElement(TooltipText, { size: TEXT_SIZE.s }, props.content); },
        render: function (tooltipProps) {
            return (React.createElement("div", { className: cn(styles.root, !props.disabled && !props.inactive && styles.normal, props.disabled && styles.disabled, props.inactive && styles.inactive) },
                React.createElement("div", { ref: ref, className: cn(styles.text, props.justify === COLUMN_CONTENT_JUSTIFY.end && styles.textJustifyEnd), onMouseEnter: onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }, props.content)));
        }
    });
    var elementContent = (React.createElement("div", { className: cn(styles.root, !props.disabled && !props.inactive && styles.normal, props.disabled && styles.disabled, props.inactive && styles.inactive) },
        React.createElement("div", { ref: ref, className: cn(styles.text, props.justify === COLUMN_CONTENT_JUSTIFY.end && styles.textJustifyEnd) }, props.content)));
    return isText ? textContent : elementContent;
});
//# sourceMappingURL=GridNormalCell.js.map